import { Request } from '../classes/request';
import { DepreciationAsset } from '../interfaces/depreciationAsset';

export function parseDepreciationAssets(request: Request): void {
    const raw = request.DepreciationAssets as unknown;

    if (raw == null || raw === '') {
        request.DepreciationAssets = null;
        return;
    }

    if (typeof raw === 'string') {
        try {
            const parsed = JSON.parse(raw);
            request.DepreciationAssets = Array.isArray(parsed) ? parsed : null;
        } catch {
            request.DepreciationAssets = null;
        }
        return;
    }

    if (Array.isArray(raw)) {
        request.DepreciationAssets = raw;
        return;
    }

    request.DepreciationAssets = null;
}

export function hasMultipleDepreciationAssets(assets: DepreciationAsset[] | null | undefined): boolean {
    return Array.isArray(assets) && assets.length > 0;
}

export function createEmptyDepreciationAsset(): DepreciationAsset {
    return { description: '', rate: null };
}

export function createDefaultDepreciationAssets(count = 2): DepreciationAsset[] {
    return Array.from({ length: count }, () => createEmptyDepreciationAsset());
}

export function isDepreciationRateValueInvalid(rate: number | string | null | undefined): boolean {
    if (rate === null || rate === undefined) {
        return true;
    }

    const rateText = rate.toString().trim();
    if (rateText.length === 0) {
        return true;
    }

    const numericRate = Number(rate);
    return isNaN(numericRate) || numericRate < 0 || numericRate > 100;
}

export function isDepreciationDataInvalid(request: Request, multipleMode: boolean): boolean {
    if (request.FKIDRequestType !== 6 && request.FKIDRequestType !== 7) {
        return false;
    }

    if (multipleMode) {
        const assets = request.DepreciationAssets ?? [];
        if (assets.length < 2) {
            return true;
        }

        return assets.some(asset =>
            !asset.description?.trim() || asset.description.trim().length < 2 ||
            isDepreciationRateValueInvalid(asset.rate)
        );
    }

    return isDepreciationRateValueInvalid(request.DepreciationRate);
}

export function syncDepreciationFieldsForSave(request: Request, multipleMode: boolean): void {
    if (request.FKIDRequestType !== 6 && request.FKIDRequestType !== 7) {
        return;
    }

    if (multipleMode) {
        request.DepreciationRate = null;
    } else {
        request.DepreciationAssets = null;
    }
}

export function initializeDepreciationAssetsState(request: Request): boolean {
    parseDepreciationAssets(request);
    return hasMultipleDepreciationAssets(request.DepreciationAssets);
}
